"use strict";
module.exports = {
    entityModel: 'endCustomerOrganization',
    events: {
        END_CUSTOMER_ORGANIZATION_UPDATED: 'END_CUSTOMER_ORGANIZATION_UPDATED',
        END_CUSTOMER_ORGANIZATION_CREATED: 'END_CUSTOMER_ORGANIZATION_CREATED',
    },
    actions: {
        get: 'v1.endCustomerOrganization.get',
        list: 'v1.endCustomerOrganization.list',
        addShopUser: 'v1.endCustomerOrganization.addShopUser',
        upsert: 'v1.endCustomerOrganization.upsert',
        upsertWhenEmpty: 'v1.endCustomerOrganization.upsertWhenEmpty',
        updateWhenEmpty: 'v1.endCustomerOrganization.updateWhenEmpty',
        update: 'v1.endCustomerOrganization.update',
    },
    endCustomerOrganizationMemberships: {
        roles: {
            customerSubUnitAdmin: 'customerSubUnitAdmin',
            customerSubUnitPurchaser: 'customerSubUnitPurchaser',
            customerSubUnitPurchaserManager: 'customerSubUnitPurchaserManager',
            customerSubUnitPurchaserAssociateManager: 'customerSubUnitPurchaserAssociateManager',
        },
    },
};
